// extracted by mini-css-extract-plugin
export default {"layout":"LayoutComponent_layout__NhjdE","content":"LayoutComponent_content__D5Szd","footer":"LayoutComponent_footer__JIgrR"};